unit View.Operadoras_Cartao.List;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, Math,

  WEBLib.StdCtrls, Web, JS, WEBLib.Lists,

  App.Types, WEBLib.Controls, WEBLib.Grids, Data.DB,
  XData.Web.Dataset, WEBLib.DBCtrls, WEBLib.DB, WEBLib.ExtCtrls,

  XData.Web.JsonDataset,

  Grid.Plugins,
  Crud.Utils, UUtils;

type
  TFViewOperadoras_CartaoList = class(TForm)
    btNew: TButton;
    Operadoras_CartaoDataset: TXDataWebDataSet;
    Operadoras_CartaoDatasetid: TIntegerField;
    Operadoras_CartaoDatasetaliado_id: TIntegerField;
    Operadoras_CartaoDatasetdata_base_id: TIntegerField;
    Operadoras_CartaoDatasetnome: TStringField;
    Operadoras_CartaoDatasetconta_id: TIntegerField;
    Operadoras_CartaoDatasetcnpj: TStringField;
    Operadoras_CartaoDatasetendereco: TStringField;
    Operadoras_CartaoDatasetnumero: TIntegerField;
    Operadoras_CartaoDatasetbairro: TStringField;
    Operadoras_CartaoDatasetcep: TStringField;
    Operadoras_CartaoDatasetcidade_id: TIntegerField;
    Operadoras_CartaoDatasettaxa_administracao: TFloatField;
    Operadoras_CartaoDatasetsigla: TStringField;
    Operadoras_CartaoDatasetcodigo_instituicao: TStringField;
    Operadoras_CartaoDatasetenviar_pdv: TBooleanField;
    Operadoras_CartaoDatasetcodigo_interno: TIntegerField;
    Operadoras_CartaoDatasetexcluido: TBooleanField;
    Operadoras_CartaoDatasetinclusao: TDateTimeField;
    Operadoras_CartaoDatasetalteracao: TDateTimeField;
    Operadoras_CartaoDatasetexclusao: TDateTimeField;
    WebDBTableControl1: TDBTableControl;
    WebDataSource: TDataSource;
    cbPageSize: TComboBox;
    edSearch: TEdit;
    lbPaginationInfo: TLabel;
    lcPaginator: TListControl;
    procedure WebFormCreate(Sender: TObject);
    procedure btNewClick(Sender: TObject);
    procedure WebDBTableControl1GetCellChildren(Sender: TObject; ACol,
      ARow: Integer; AField: TField; AValue: string; AElement: TJSHTMLElementRecord);
    procedure cbPageSizeChange(Sender: TObject);
    procedure edSearchChange(Sender: TObject);
  private
    FEditProc: TEditProc;
    FGridPlugin: TGridPlugin;
  public
    class function CreateForm(AElementID: string; AShowEditProc: TEditProc): TForm;
  protected procedure LoadDFMValues; override; end;

var
  FViewOperadoras_CartaoList: TFViewOperadoras_CartaoList;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewOperadoras_CartaoList }

procedure TFViewOperadoras_CartaoList.cbPageSizeChange(Sender: TObject);
begin
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text), True);
end;

class function TFViewOperadoras_CartaoList.CreateForm(AElementID: string;
  AShowEditProc: TEditProc): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewOperadoras_CartaoList(AForm).FEditProc := AShowEditProc;
  end;

begin
  Application.CreateForm(TFViewOperadoras_CartaoList, AElementID, Result, @AfterCreate);
end;

procedure TFViewOperadoras_CartaoList.edSearchChange(Sender: TObject);
begin
  FGridPlugin.SetFilterText(edSearch.Text, True);
end;

procedure TFViewOperadoras_CartaoList.btNewClick(Sender: TObject);
begin
  FEditProc( nil );
end;

procedure TFViewOperadoras_CartaoList.WebDBTableControl1GetCellChildren(Sender: TObject;
  ACol, ARow: Integer; AField: TField; AValue: string;
  AElement: TJSHTMLElementRecord);
var
  RecordId: JSValue;

  procedure EditButtonClick(Sender: TObject);
  begin
    FEditProc(RecordId);
  end;

var
  Button: TButton;
begin
  if ARow = 0 then
    Exit;

  if WebDBTableControl1.Columns[ACol].Title = 'Actions' then
  begin
    RecordId := TCrudUtils.GetIdFromObject(
      Operadoras_CartaoDataset.Connection.Model.DefaultSchema.FindEntityType(Operadoras_CartaoDataset.EntitySetName),
      Operadoras_CartaoDataset.CurrentData
    );
    Button := TButton.Create(nil);
    Button.Caption := 'Edit';
    Button.OnClick := @EditButtonClick;
    Button.ElementClassName := 'btn btn-outline btn-default btn-xs';
    Button.ParentElement := AElement.element;
    Button.WidthStyle := TSizeStyle.ssAuto;
    Button.HeightStyle := TSizeStyle.ssAuto;
  end;
end;

procedure TFViewOperadoras_CartaoList.WebFormCreate(Sender: TObject);
begin
  TUtils.SetValorDicionarioClasses('operadoras_cartao', 'active');
  TUtils.SetValorDicionarioClasses('cadastros_collapse', 'show');
  TUtils.SetValorDicionarioClasses('menu_cadastros', 'active');
  TUtils.SetPaginaSelecionada;

  FGridPlugin := TGridPlugin.Create(
    WebDBTableControl1,
    Operadoras_CartaoDataset,
    lcPaginator,
    lbPaginationInfo
  );
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text));
  FGridPlugin.SetFilterText(edSearch.Text);
  FGridPlugin.Load;
end;

procedure TFViewOperadoras_CartaoList.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lbPaginationInfo := TLabel.Create('view.operadoras_cartao.list.pagination.info');
  btNew := TButton.Create('view.operadoras_cartao.list.newbutton');
  WebDBTableControl1 := TDBTableControl.Create('view.operadoras_cartao.list.table');
  cbPageSize := TComboBox.Create('view.operadoras_cartao.list.cbPageSize');
  edSearch := TEdit.Create('view.operadoras_cartao.list.search');
  lcPaginator := TListControl.Create('view.operadoras_cartao.list.pagination');
  Operadoras_CartaoDataset := TXDataWebDataSet.Create(Self);
  Operadoras_CartaoDatasetid := TIntegerField.Create(Self);
  Operadoras_CartaoDatasetaliado_id := TIntegerField.Create(Self);
  Operadoras_CartaoDatasetdata_base_id := TIntegerField.Create(Self);
  Operadoras_CartaoDatasetnome := TStringField.Create(Self);
  Operadoras_CartaoDatasetconta_id := TIntegerField.Create(Self);
  Operadoras_CartaoDatasetcnpj := TStringField.Create(Self);
  Operadoras_CartaoDatasetendereco := TStringField.Create(Self);
  Operadoras_CartaoDatasetnumero := TIntegerField.Create(Self);
  Operadoras_CartaoDatasetbairro := TStringField.Create(Self);
  Operadoras_CartaoDatasetcep := TStringField.Create(Self);
  Operadoras_CartaoDatasetcidade_id := TIntegerField.Create(Self);
  Operadoras_CartaoDatasettaxa_administracao := TFloatField.Create(Self);
  Operadoras_CartaoDatasetsigla := TStringField.Create(Self);
  Operadoras_CartaoDatasetcodigo_instituicao := TStringField.Create(Self);
  Operadoras_CartaoDatasetenviar_pdv := TBooleanField.Create(Self);
  Operadoras_CartaoDatasetcodigo_interno := TIntegerField.Create(Self);
  Operadoras_CartaoDatasetexcluido := TBooleanField.Create(Self);
  Operadoras_CartaoDatasetinclusao := TDateTimeField.Create(Self);
  Operadoras_CartaoDatasetalteracao := TDateTimeField.Create(Self);
  Operadoras_CartaoDatasetexclusao := TDateTimeField.Create(Self);
  WebDataSource := TDataSource.Create(Self);

  lbPaginationInfo.BeforeLoadDFMValues;
  btNew.BeforeLoadDFMValues;
  WebDBTableControl1.BeforeLoadDFMValues;
  cbPageSize.BeforeLoadDFMValues;
  edSearch.BeforeLoadDFMValues;
  lcPaginator.BeforeLoadDFMValues;
  Operadoras_CartaoDataset.BeforeLoadDFMValues;
  Operadoras_CartaoDatasetid.BeforeLoadDFMValues;
  Operadoras_CartaoDatasetaliado_id.BeforeLoadDFMValues;
  Operadoras_CartaoDatasetdata_base_id.BeforeLoadDFMValues;
  Operadoras_CartaoDatasetnome.BeforeLoadDFMValues;
  Operadoras_CartaoDatasetconta_id.BeforeLoadDFMValues;
  Operadoras_CartaoDatasetcnpj.BeforeLoadDFMValues;
  Operadoras_CartaoDatasetendereco.BeforeLoadDFMValues;
  Operadoras_CartaoDatasetnumero.BeforeLoadDFMValues;
  Operadoras_CartaoDatasetbairro.BeforeLoadDFMValues;
  Operadoras_CartaoDatasetcep.BeforeLoadDFMValues;
  Operadoras_CartaoDatasetcidade_id.BeforeLoadDFMValues;
  Operadoras_CartaoDatasettaxa_administracao.BeforeLoadDFMValues;
  Operadoras_CartaoDatasetsigla.BeforeLoadDFMValues;
  Operadoras_CartaoDatasetcodigo_instituicao.BeforeLoadDFMValues;
  Operadoras_CartaoDatasetenviar_pdv.BeforeLoadDFMValues;
  Operadoras_CartaoDatasetcodigo_interno.BeforeLoadDFMValues;
  Operadoras_CartaoDatasetexcluido.BeforeLoadDFMValues;
  Operadoras_CartaoDatasetinclusao.BeforeLoadDFMValues;
  Operadoras_CartaoDatasetalteracao.BeforeLoadDFMValues;
  Operadoras_CartaoDatasetexclusao.BeforeLoadDFMValues;
  WebDataSource.BeforeLoadDFMValues;
  try
    Name := 'FViewOperadoras_CartaoList';
    Width := 695;
    Height := 500;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    lbPaginationInfo.SetParentComponent(Self);
    lbPaginationInfo.Name := 'lbPaginationInfo';
    lbPaginationInfo.Left := 8;
    lbPaginationInfo.Top := 376;
    lbPaginationInfo.Width := 141;
    lbPaginationInfo.Height := 13;
    lbPaginationInfo.Caption := 'Showing 1 to 10 of 57 entries';
    lbPaginationInfo.HeightPercent := 100.000000000000000000;
    lbPaginationInfo.WidthPercent := 100.000000000000000000;
    btNew.SetParentComponent(Self);
    btNew.Name := 'btNew';
    btNew.Left := 8;
    btNew.Top := 8;
    btNew.Width := 50;
    btNew.Height := 25;
    btNew.Caption := 'New';
    btNew.HeightPercent := 100.000000000000000000;
    btNew.WidthPercent := 100.000000000000000000;
    SetEvent(btNew, Self, 'OnClick', 'btNewClick');
    WebDBTableControl1.SetParentComponent(Self);
    WebDBTableControl1.Name := 'WebDBTableControl1';
    WebDBTableControl1.Left := 8;
    WebDBTableControl1.Top := 94;
    WebDBTableControl1.Width := 521;
    WebDBTableControl1.Height := 265;
    WebDBTableControl1.ElementClassName := 'table-responsive';
    WebDBTableControl1.BorderColor := clSilver;
    WebDBTableControl1.ColHeader := False;
    WebDBTableControl1.ElementTableClassName := 'table table-striped table-bordered table-hover dataTable';
    SetEvent(WebDBTableControl1, Self, 'OnGetCellChildren', 'WebDBTableControl1GetCellChildren');
    WebDBTableControl1.Columns.Clear;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'id';
      Title := 'id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'aliado_id';
      Title := 'aliado_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'data_base_id';
      Title := 'data_base_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'nome';
      Title := 'nome';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'conta_id';
      Title := 'conta_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'cnpj';
      Title := 'cnpj';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'endereco';
      Title := 'endereco';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'numero';
      Title := 'numero';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'bairro';
      Title := 'bairro';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'cep';
      Title := 'cep';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'cidade_id';
      Title := 'cidade_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'taxa_administracao';
      Title := 'taxa_administracao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'sigla';
      Title := 'sigla';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'codigo_instituicao';
      Title := 'codigo_instituicao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'enviar_pdv';
      Title := 'enviar_pdv';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'codigo_interno';
      Title := 'codigo_interno';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'excluido';
      Title := 'excluido';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'inclusao';
      Title := 'inclusao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'alteracao';
      Title := 'alteracao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'exclusao';
      Title := 'exclusao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      Title := 'Actions';
    end;
    WebDBTableControl1.DataSource := WebDataSource;
    cbPageSize.SetParentComponent(Self);
    cbPageSize.Name := 'cbPageSize';
    cbPageSize.Left := 8;
    cbPageSize.Top := 67;
    cbPageSize.Width := 81;
    cbPageSize.Height := 21;
    cbPageSize.HeightPercent := 100.000000000000000000;
    cbPageSize.TabOrder := 2;
    cbPageSize.Text := '10';
    cbPageSize.WidthPercent := 100.000000000000000000;
    SetEvent(cbPageSize, Self, 'OnChange', 'cbPageSizeChange');
    cbPageSize.ItemIndex := 0;
    cbPageSize.Items.BeginUpdate;
    try
      cbPageSize.Items.Clear;
      cbPageSize.Items.Add('10');
      cbPageSize.Items.Add('25');
      cbPageSize.Items.Add('50');
      cbPageSize.Items.Add('100');
    finally
      cbPageSize.Items.EndUpdate;
    end;
    edSearch.SetParentComponent(Self);
    edSearch.Name := 'edSearch';
    edSearch.Left := 408;
    edSearch.Top := 67;
    edSearch.Width := 121;
    edSearch.Height := 21;
    edSearch.HeightPercent := 100.000000000000000000;
    edSearch.TabOrder := 3;
    edSearch.WidthPercent := 100.000000000000000000;
    SetEvent(edSearch, Self, 'OnChange', 'edSearchChange');
    lcPaginator.SetParentComponent(Self);
    lcPaginator.Name := 'lcPaginator';
    lcPaginator.Left := 240;
    lcPaginator.Top := 365;
    lcPaginator.Width := 289;
    lcPaginator.Height := 25;
    lcPaginator.HeightPercent := 100.000000000000000000;
    lcPaginator.WidthPercent := 100.000000000000000000;
    lcPaginator.DefaultItemClassName := 'page-item';
    lcPaginator.DefaultItemLinkClassName := 'page-link';
    lcPaginator.ElementListClassName := 'pagination';
    lcPaginator.Style := lsPagination;
    Operadoras_CartaoDataset.SetParentComponent(Self);
    Operadoras_CartaoDataset.Name := 'Operadoras_CartaoDataset';
    Operadoras_CartaoDataset.EntitySetName := 'Operadoras_Cartao';
    Operadoras_CartaoDataset.Connection := DMConnection.ApiConnection;
    Operadoras_CartaoDataset.Left := 72;
    Operadoras_CartaoDataset.Top := 144;
    Operadoras_CartaoDatasetid.SetParentComponent(Operadoras_CartaoDataset);
    Operadoras_CartaoDatasetid.Name := 'Operadoras_CartaoDatasetid';
    Operadoras_CartaoDatasetid.FieldName := 'id';
    Operadoras_CartaoDatasetid.Required := True;
    Operadoras_CartaoDatasetaliado_id.SetParentComponent(Operadoras_CartaoDataset);
    Operadoras_CartaoDatasetaliado_id.Name := 'Operadoras_CartaoDatasetaliado_id';
    Operadoras_CartaoDatasetaliado_id.FieldName := 'aliado_id';
    Operadoras_CartaoDatasetaliado_id.Required := True;
    Operadoras_CartaoDatasetdata_base_id.SetParentComponent(Operadoras_CartaoDataset);
    Operadoras_CartaoDatasetdata_base_id.Name := 'Operadoras_CartaoDatasetdata_base_id';
    Operadoras_CartaoDatasetdata_base_id.FieldName := 'data_base_id';
    Operadoras_CartaoDatasetdata_base_id.Required := True;
    Operadoras_CartaoDatasetnome.SetParentComponent(Operadoras_CartaoDataset);
    Operadoras_CartaoDatasetnome.Name := 'Operadoras_CartaoDatasetnome';
    Operadoras_CartaoDatasetnome.FieldName := 'nome';
    Operadoras_CartaoDatasetnome.Required := True;
    Operadoras_CartaoDatasetnome.Size := 255;
    Operadoras_CartaoDatasetconta_id.SetParentComponent(Operadoras_CartaoDataset);
    Operadoras_CartaoDatasetconta_id.Name := 'Operadoras_CartaoDatasetconta_id';
    Operadoras_CartaoDatasetconta_id.FieldName := 'conta_id';
    Operadoras_CartaoDatasetcnpj.SetParentComponent(Operadoras_CartaoDataset);
    Operadoras_CartaoDatasetcnpj.Name := 'Operadoras_CartaoDatasetcnpj';
    Operadoras_CartaoDatasetcnpj.FieldName := 'cnpj';
    Operadoras_CartaoDatasetcnpj.Size := 255;
    Operadoras_CartaoDatasetendereco.SetParentComponent(Operadoras_CartaoDataset);
    Operadoras_CartaoDatasetendereco.Name := 'Operadoras_CartaoDatasetendereco';
    Operadoras_CartaoDatasetendereco.FieldName := 'endereco';
    Operadoras_CartaoDatasetendereco.Size := 255;
    Operadoras_CartaoDatasetnumero.SetParentComponent(Operadoras_CartaoDataset);
    Operadoras_CartaoDatasetnumero.Name := 'Operadoras_CartaoDatasetnumero';
    Operadoras_CartaoDatasetnumero.FieldName := 'numero';
    Operadoras_CartaoDatasetbairro.SetParentComponent(Operadoras_CartaoDataset);
    Operadoras_CartaoDatasetbairro.Name := 'Operadoras_CartaoDatasetbairro';
    Operadoras_CartaoDatasetbairro.FieldName := 'bairro';
    Operadoras_CartaoDatasetbairro.Size := 255;
    Operadoras_CartaoDatasetcep.SetParentComponent(Operadoras_CartaoDataset);
    Operadoras_CartaoDatasetcep.Name := 'Operadoras_CartaoDatasetcep';
    Operadoras_CartaoDatasetcep.FieldName := 'cep';
    Operadoras_CartaoDatasetcep.Size := 255;
    Operadoras_CartaoDatasetcidade_id.SetParentComponent(Operadoras_CartaoDataset);
    Operadoras_CartaoDatasetcidade_id.Name := 'Operadoras_CartaoDatasetcidade_id';
    Operadoras_CartaoDatasetcidade_id.FieldName := 'cidade_id';
    Operadoras_CartaoDatasettaxa_administracao.SetParentComponent(Operadoras_CartaoDataset);
    Operadoras_CartaoDatasettaxa_administracao.Name := 'Operadoras_CartaoDatasettaxa_administracao';
    Operadoras_CartaoDatasettaxa_administracao.FieldName := 'taxa_administracao';
    Operadoras_CartaoDatasetsigla.SetParentComponent(Operadoras_CartaoDataset);
    Operadoras_CartaoDatasetsigla.Name := 'Operadoras_CartaoDatasetsigla';
    Operadoras_CartaoDatasetsigla.FieldName := 'sigla';
    Operadoras_CartaoDatasetsigla.Size := 255;
    Operadoras_CartaoDatasetcodigo_instituicao.SetParentComponent(Operadoras_CartaoDataset);
    Operadoras_CartaoDatasetcodigo_instituicao.Name := 'Operadoras_CartaoDatasetcodigo_instituicao';
    Operadoras_CartaoDatasetcodigo_instituicao.FieldName := 'codigo_instituicao';
    Operadoras_CartaoDatasetcodigo_instituicao.Size := 255;
    Operadoras_CartaoDatasetenviar_pdv.SetParentComponent(Operadoras_CartaoDataset);
    Operadoras_CartaoDatasetenviar_pdv.Name := 'Operadoras_CartaoDatasetenviar_pdv';
    Operadoras_CartaoDatasetenviar_pdv.FieldName := 'enviar_pdv';
    Operadoras_CartaoDatasetenviar_pdv.Required := True;
    Operadoras_CartaoDatasetcodigo_interno.SetParentComponent(Operadoras_CartaoDataset);
    Operadoras_CartaoDatasetcodigo_interno.Name := 'Operadoras_CartaoDatasetcodigo_interno';
    Operadoras_CartaoDatasetcodigo_interno.FieldName := 'codigo_interno';
    Operadoras_CartaoDatasetcodigo_interno.Required := True;
    Operadoras_CartaoDatasetexcluido.SetParentComponent(Operadoras_CartaoDataset);
    Operadoras_CartaoDatasetexcluido.Name := 'Operadoras_CartaoDatasetexcluido';
    Operadoras_CartaoDatasetexcluido.FieldName := 'excluido';
    Operadoras_CartaoDatasetinclusao.SetParentComponent(Operadoras_CartaoDataset);
    Operadoras_CartaoDatasetinclusao.Name := 'Operadoras_CartaoDatasetinclusao';
    Operadoras_CartaoDatasetinclusao.FieldName := 'inclusao';
    Operadoras_CartaoDatasetalteracao.SetParentComponent(Operadoras_CartaoDataset);
    Operadoras_CartaoDatasetalteracao.Name := 'Operadoras_CartaoDatasetalteracao';
    Operadoras_CartaoDatasetalteracao.FieldName := 'alteracao';
    Operadoras_CartaoDatasetexclusao.SetParentComponent(Operadoras_CartaoDataset);
    Operadoras_CartaoDatasetexclusao.Name := 'Operadoras_CartaoDatasetexclusao';
    Operadoras_CartaoDatasetexclusao.FieldName := 'exclusao';
    WebDataSource.SetParentComponent(Self);
    WebDataSource.Name := 'WebDataSource';
    WebDataSource.DataSet := Operadoras_CartaoDataset;
    WebDataSource.Left := 72;
    WebDataSource.Top := 200;
  finally
    lbPaginationInfo.AfterLoadDFMValues;
    btNew.AfterLoadDFMValues;
    WebDBTableControl1.AfterLoadDFMValues;
    cbPageSize.AfterLoadDFMValues;
    edSearch.AfterLoadDFMValues;
    lcPaginator.AfterLoadDFMValues;
    Operadoras_CartaoDataset.AfterLoadDFMValues;
    Operadoras_CartaoDatasetid.AfterLoadDFMValues;
    Operadoras_CartaoDatasetaliado_id.AfterLoadDFMValues;
    Operadoras_CartaoDatasetdata_base_id.AfterLoadDFMValues;
    Operadoras_CartaoDatasetnome.AfterLoadDFMValues;
    Operadoras_CartaoDatasetconta_id.AfterLoadDFMValues;
    Operadoras_CartaoDatasetcnpj.AfterLoadDFMValues;
    Operadoras_CartaoDatasetendereco.AfterLoadDFMValues;
    Operadoras_CartaoDatasetnumero.AfterLoadDFMValues;
    Operadoras_CartaoDatasetbairro.AfterLoadDFMValues;
    Operadoras_CartaoDatasetcep.AfterLoadDFMValues;
    Operadoras_CartaoDatasetcidade_id.AfterLoadDFMValues;
    Operadoras_CartaoDatasettaxa_administracao.AfterLoadDFMValues;
    Operadoras_CartaoDatasetsigla.AfterLoadDFMValues;
    Operadoras_CartaoDatasetcodigo_instituicao.AfterLoadDFMValues;
    Operadoras_CartaoDatasetenviar_pdv.AfterLoadDFMValues;
    Operadoras_CartaoDatasetcodigo_interno.AfterLoadDFMValues;
    Operadoras_CartaoDatasetexcluido.AfterLoadDFMValues;
    Operadoras_CartaoDatasetinclusao.AfterLoadDFMValues;
    Operadoras_CartaoDatasetalteracao.AfterLoadDFMValues;
    Operadoras_CartaoDatasetexclusao.AfterLoadDFMValues;
    WebDataSource.AfterLoadDFMValues;
  end;
end;

end.
